
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import { partsQuantityRules } from "@common/src/utils/verify";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
import PartsSelectionDialog from "@common/src/components/scope/parts-selection-dialog/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import InventoryCheckPrint from "./components/inventory-check-print.vue";
import _ from "lodash-es";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import dayjs from "dayjs";

const staff = namespace("staff");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const common_warehouse = namespace("common_warehouse");
const partsCategory = namespace("parts-category");

@Component({ components: { MyCheckbox, PartsSelectionDialog, TextTips, InventoryCheckPrint, DataImport } })
@InjectFunction("permit", "emptyToLine", "splitThousands", "addCurrencyUnit")
@Table("loadListData")
@Table.DataImport({
  actionUrl: "/filecloud/importStocktakingParts",
  templateCode: "importStocktakingParts"
})
export default class InventoryCheckEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @user.State userData;
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_warehouse.Action queryWarehouseShelfTree;
  @inventory.Action getPartsInventoryList;
  @inventory.Action queryStocktakingParts;
  @inventory.Action queryStocktaking;
  @inventory.Action updateStocktakingPartsRow;
  @inventory.Action removePartialStocktakingParts;
  @inventory.Action saveAddPartialStocktakingParts;
  @inventory.Action saveAllStocktaking;
  @partsCategory.Action getCategoryList;

  get breadData() {
    const pathName = this.checkType === "temporarily" ? t("v216_6.new-zero-disk") : t("v216_6.new-full-disk");
    const editPathName =
      this.checkType === "temporarily"
        ? t("v216_6.continue-inventory-zero-inventory")
        : t("v216_6.continue-inventory-overall");
    return [
      { name: t("v216_6.inventory-check"), path: "/inventory/inventory-check/list" },
      { name: this.isAdd ? pathName : editPathName }
    ];
  }
  get isAdd() {
    return this.$route.name === "InventoryCheckAdd";
  }
  orderFormDataRules = {
    warehouseCode: [{ required: true, message: t("v216_6.please-select-the-inventory-warehouse"), trigger: "change" }],
    stocktakingUser: [{ required: true, message: t("v216_6.please-select-the-inventory-taker"), trigger: "change" }],
    stocktakingDate: [{ required: true, message: t("v216_6.please-select-the-inventory-date"), trigger: "change" }]
  };
  advisorList: any = [];
  orderFormData: any = {
    stocktakingCode: "",
    stocktakingDate: "",
    stocktakingRemark: "",
    stocktakingStatus: 1, // 1 保存 2 已完成
    stocktakingUser: "",
    warehouseCode: "",
    stocktakingType: "" //1:零盘 2:全盘
  };
  created() {
    this.setPBPX(100);
    this.init();
  }
  // 过滤空children
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  categoryList = [];
  async init() {
    const categoryRes = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(categoryRes.data || []);
    this.getDictionaryList("stocktaking_parts_status").then(data => {
      const obj = {};
      data.map(item => {
        obj[item.dataValue] = item.dataDesc;
      });
      this.checkStatusValueMap = obj;
    });
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.isAdd && (this.orderFormData.stocktakingUser = this.userData.userCode);
    });
    await this.queryWarehouseShelfTree({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.warehouseList = data.data?.warehouseList || [];
    });
    this.getInventoryCheckDetail();
    this.loadListData();
    if (this.isAdd) {
      this.orderFormData.stocktakingDate = dayjs().format("YYYYMMDD");
    }
  }
  get orderId() {
    return this.$route.params.id;
  }
  checkAddData(): boolean {
    if (this.checkPartsList < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    return true;
  }
  operationName: string = "";
  handleSaveInventoryCheck() {
    this.operationName = "save";
    this.emitSaveinventoryCheck();
  }
  handleSubmitInventoryCheck() {
    this.operationName = "complete";
    this.emitSaveinventoryCheck();
  }
  emitSaveinventoryCheck() {
    (this.$refs["inWarehouseInfo"] as any).validate(async valid => {
      if (valid && this.checkAddData()) {
        if (this.operationName === "complete") {
          await this.$confirm(t("v3_5_0.inventory-check-submit-tips"), t("v210831.tips"), {
            confirmButtonText: t("v210831.determine"),
            cancelButtonText: t("base.cancel"),
            type: "warning"
          });
        }
        this.btnStartLoading();
        const saveApi = this.checkType === "all" ? this.saveAllStocktaking : this.saveAddPartialStocktakingParts;
        saveApi({
          ...this.orderFormData,
          stocktakingStatus: this.operationName === "save" ? "1" : "2"
        })
          .then(data => {
            this.$message.success(t("v210831.successful-execution"));
            this.$router.push(`/inventory/inventory-check/view/${data.data}`);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
  queryWarehouseAllParts() {
    return this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 99999,
      warehouseCode: this.orderFormData.warehouseCode,
      findInvEmpty: "1"
    }).then(data => {
      return data.data.list;
    });
  }
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips() {
    (this.$refs["inWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.showInConfirmTips = true;
      }
    });
  }
  handleFilterChange() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  warehouseList: any = [];
  showSelectParts = false;
  handleShowPartsSelectDialog() {
    if (!this.orderFormData.warehouseCode) {
      return this.$message.error(t("v216_6.please-select-a-warehouse-first"));
    }
    this.showSelectParts = true;
  }
  shelfList: any = [];
  checkStatusValueMap: any = {};
  handleConfirmSelect(rows, type: "select" | "import" = "select") {
    const selectedArr = [];
    rows.forEach(parts => {
      const findIndex = this.queryIndexByOriginList(parts);
      const newParts = {
        ...parts,
        status: type === "import" ? parts.status : 1,
        statusDesc: type === "import" ? parts.statusDesc : this.checkStatusValueMap[1],
        showInputProper: false,
        inventoryActualQty: type === "import" ? parts.inventoryActualQty : parts.qty,
        inventoryQty: type === "import" ? parts.inventoryQty : parts.qty,
        inputQty: type === "import" ? parts.inventoryActualQty : "",
        diffQty: type === "import" ? parts.profitLossQty : 0
      };
      if (findIndex < 0) {
        selectedArr.push(newParts);
      } else {
        if (type === "import") {
          this.orderFormData.partsParams.splice(findIndex, 1, newParts);
        }
      }
    });
    if (type === "select") {
      this.saveAddPartialStocktakingParts({
        ...this.orderFormData,
        partsParams: selectedArr
      }).then(() => {
        this.loadListData();
      });
    }
    this.showSelectParts = false;
  }
  handleShowInventoryInput(row) {
    row.showInputProper = true;
    const key = `popover-${row.partsCode}-${row.shelfCode}`;
    // 设置了fixed的表格列，Popover 会重复弹出.
    this.$nextTick(() => {
      const curId = (this.$refs[key] as any).$refs.popper.id;
      const props = document.querySelectorAll(".page-inventory-check-edit-inventory-input-proper");
      props.forEach(prop => {
        if (curId !== prop.id) {
          (prop as any).style.display = "none";
        }
      });
    });
  }
  handleCancel(row) {
    row.inputQty = "";
    row.showInputProper = false;
  }
  handleconfirmQty(row) {
    if (_.isNil(row.inputQty) || row.inputQty === "") {
      this.$message.error(t("v216_6.please-enter-the-actual-inventory-quantity"));
      return false;
    }
    const qtyRuleCheck = partsQuantityRules(row.inputQty);
    if (!qtyRuleCheck.success) {
      this.$message.error(qtyRuleCheck.msg);
      return false;
    }
    this.updateStocktakingPartsRow({
      inventoryActualQty: row.inputQty,
      partsCode: row.partsCode,
      shelfCode: row.shelfCode,
      stocktakingCode: this.orderId
    }).then(() => {
      row.showInputProper = false;
      row.inputQty = "";
      this.loadListData();
    });
  }
  diffAddSymbol(num) {
    num = Number(num);
    return num > 0 ? "+" + num : num;
  }
  handleDeleteRow(row) {
    this.removePartialStocktakingParts({
      partsCode: row.partsCode,
      shelfCode: row.shelfCode,
      stocktakingCode: this.orderId
    }).then(() => {
      this.loadListData();
    });
  }
  queryIndexByOriginList(showParts) {
    return this.checkPartsList.findIndex(
      originParts => originParts.partsCode + originParts.shelfCode === showParts.partsCode + showParts.shelfCode
    );
  }
  get queryPartsParams() {
    return {
      warehouseCode: this.orderFormData.warehouseCode,
      stocktakingCode: this.orderId
    };
  }
  get importParamsData() {
    return {
      warehouseCode: this.orderFormData.warehouseCode,
      stocktakingCode: this.orderId
    };
  }
  handleImportSuccess() {
    this.$message.success(t("v3_2_0.import-successful"));
    this.mix_pageNum = 1;
    this.loadListData();
    // this.mix_handlehideImportModal();
  }
  handleClickImport() {
    if (!this.orderFormData.warehouseCode) {
      return this.$message.error(t("v216_6.please-select-the-inventory-warehouse"));
    }
    this.mix_handleShowImportModal();
  }
  get totalProfitNum() {
    return (Number(this.summaryData.deficitQuantity) + Number(this.summaryData.surplusQuantity)).toFixed(2);
  }
  stocktakingDateOption: any = {
    disabledDate(row) {
      return dayjs(row).isAfter(dayjs().endOf("d"));
    }
  };

  get checkType() {
    return this.$route.query.type || (this.orderFormData.stocktakingType === "2" ? "all" : "temporarily");
  }
  get showImportBtn() {
    return !this.isAdd || !(this.checkType === "all");
  }
  searchForm: any = {
    partsName: "",
    showOnlyProfitAndLoss: "",
    showUnStocktakingParts: "",
    showInventoryExist: "",
    categoryCode: "",
    front_categoryCode: []
  };
  checkPartsList: any = [];
  summaryData: any = {
    deficitQuantity: 0,
    surplusQuantity: 0
  };
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryStocktakingParts({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      stocktakingCode: this.orderId,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.checkPartsList = (data?.data?.list || []).map(item => {
        item.showInputProper = false;
        return item;
      });
      this.summaryData = _.pick(data.data, ["countStocktakingPartsDetail", "deficitQuantity", "surplusQuantity"]);
      return data;
    });
  }

  getInventoryCheckDetail() {
    this.queryStocktaking({
      stocktakingCode: this.orderId
    }).then(data => {
      data.data.stocktakingDate = dayjs(data.data.stocktakingDate).format("YYYYMMDD");
      this.orderFormData = data.data || {};
      this.handleWarehouseChange(this.orderFormData.warehouseCode);
    });
  }
  async handleWarehouseChange(val) {
    this.orderFormData.warehouseCode = val;
    this.shelfList = this.warehouseList
      .find(warehose => warehose.warehouseCode === val)
      .shelfList.map(item => {
        item.label = item.shelfDesc;
        item.value = item.shelfCode;
        return item;
      });
  }
  handleSelectAll(searchData) {
    this.saveAddPartialStocktakingParts({
      ...this.orderFormData,
      queryInventoryCondition: searchData,
      addPartsByConditionFlag: "1"
    }).then(() => {
      this.showSelectParts = false;
      this.loadListData();
    });
  }
  hanldeCategoryChange() {
    this.searchForm.categoryCode =
      this.searchForm.front_categoryCode[this.searchForm.front_categoryCode.length - 1] || "";
    this.loadListData();
  }
}
